import { cn } from "@/lib/utils";

export function Skeleton({ className, label = "Betöltés" }: { className?: string; label?: string }) {
  return (
    <div
      role="status"
      aria-label={label}
      className={cn(
        "animate-pulse rounded-lg bg-slate-200/70 dark:bg-slate-800/70",
        className
      )}
    >
      <span className="sr-only">{label}</span>
    </div>
  );
}

